/***************************************************************************************\
* jqTooltip.js
* Monica Modena / Pagano Francesco                                        			   				*
*---------------------------------------------------------------------------------------*
* This script implements the qTip Jquery plugin which is documented in detail in
* http://craigsworks.com/projects/qtip2/docs/
*************************************************************************************/

var isTouchDevice = ENV_VARS.isOnTouchDevice();

// Manage the default Options and default Events Handler
//************************************************************************************** */
function getJQTipDefaultOpts(actualTargetSelect, customOptions, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallBack){

	var qTipDefaultGroup;

	if(!isDefined(setGroup)){
		qTipDefaultGroup = 'generalGroup'; //Default Group for solo Manage
	}
	else{
		qTipDefaultGroup = setGroup;
	}

	var tipWidth = false;
	if (parseInt($(actualTargetSelect).width()) > 400 ) {
		tipWidth = $(actualTargetSelect).width() + 'px';
	}

	//Default Options
	var qTipDefaultOpts = {
			content:{
				ajax : false,
				title: {
					button: false
				}
			},
			position: {
				my: 'top center',
				at: 'bottom center',
				target : $(actualTargetSelect),
				viewport: $(window), // to adjust the tip's corners when his goes off-screen
				effect: false,
				adjust: {
					method: 'shift'
				}
			},
			show: {
				event : false, //default manual show
				modal: false,
				solo: false,
				ready: true, // Show the tooltip as soon as it's bound, vital so it shows up the first time you hover!
				delay:500
			},
			hide: {
				when: {
					event: 'unfocus inactive',
				},
				fixed: true,
				inactive: 5000,
				delay: 1500
			},
			style: {
				tip: true,
				widget : true,
				width: tipWidth,
				classes: 'de_qtip'
			},
			dcy : {
					groupSet			: qTipDefaultGroup,
					repositionManage 	: true,
					defaultInactiveForLoading : 30000,
					defaultInactiveForOptions : 5000
			}
	};

	var mergedOptions = {};

	//Extend the default options with custom options passed
	if(isDefined(customOptions)){
		$.extend(true, mergedOptions, qTipDefaultOpts, customOptions);
	}
	else{
		mergedOptions = qTipDefaultOpts;
	}

	//Forced events for show and hide
	mergedOptions = forcedEventsQtip(mergedOptions);

	//Prepare the Local Variables for Solo Manage
	var zIndex = null;
	var setMyZindex = null;
	var manualSoloForShowEvent = null;
	var manualSoloForRenderEvent = null;
	var manualSoloForFocusEvent = null;

	//###################################################################################
	//if solo property set false this method manage manually this property
	if(isDefined(mergedOptions.show) && (!isDefined(mergedOptions.show.solo) || !mergedOptions.show.solo)){
		//Manage manually z-index
		setMyZindex = function(element, zIndex){
			if(isDefined(element)){
				var api = $(element).qtip('api');

				if(isDefined(api) && isDefined(mergedOptions.style)){
					$tip = api.elements.tooltip.get(0) ;
					zIndex ? $tip.style.zIndex = parseInt(zIndex)+1 : null;
				}

			}
		};


		zIndex = parseInt($(actualTargetSelect).css('z-index'),10);

		//Manage solo property rispect to group manually
		manualSoloForShowEvent = function(event, api){
			$('.de_qtip').each(function(){
				var qtipApi = $(this).qtip('api');

				if(isDefined(actualTargetSelect) && isDefined(qtipApi) && $(actualTargetSelect).get(0) != qtipApi.elements.target.get(0) ){
					if(isDefined(qtipApi.options.dcy) && qtipApi.options.dcy.groupSet == qTipDefaultGroup ){
						destroyJQTooltip(this);
					}
					else{
						var z = $(this).css('z-index');
						if ((typeof(z) === 'number' || typeof(z) === 'string') && z !== '' && !isNaN(z)) {
							z = parseInt(z, 10);
							if (z > zIndex) {
								zIndex = z;
							}
						}
					}
				}
			});
			setMyZindex(actualTargetSelect, zIndex);
		};

		manualSoloForRenderEvent = function(event, api){
			setMyZindex(event.target, zIndex);
		};

		manualSoloForFocusEvent = function(event, api){
			event.originalEvent.originalEvent = {}; //fix for IE8
			if (event.preventDefault) {
				event.preventDefault();
			}else{
				event.returnValue = false;
			}
		};

	}
	//###########################################################################################


	//###########################################################################################

	//Manage events for default Decisyon commands
	mergedOptions.events = {
			//Called before show tooltip
			show : function(event, api){
				if(isDefined(beforeOpenCallBack) && typeof beforeOpenCallBack === 'function'){
					beforeOpenCallBack(event, api);
				}
				if(isDefined(api.options.style.textAlign)){
					$(api.elements.content).css('text-align',api.options.style.textAlign);
				}
			},
			render:function(event, api){
				//Check if manage the solo properties manually
				isDefined(manualSoloForRenderEvent) ? manualSoloForRenderEvent(event, api) : null;

				//render callback
				if(isDefined(renderCallBack) && typeof renderCallBack === 'function'){
					renderCallBack(event, api);
				}
			},
			hide: function(event, api) {
				//Free dcyHandler resource used for scroll and reposition manage
				if(api.options.dcy){
					if(isDefined(api.options.dcy.dcyHandler)){
						for(var i=0;i<api.options.dcy.dcyHandler.length;i++){
							$(api.options.dcy.dcyHandler[i]).off( ".qtipScrollManage" );
						}
					}

					if(isDefined(api.options.dcy.repositionIntervall)){
						clearInterval(api.options.dcy.repositionIntervall);
					}

					if(isDefined(api.options.dcy.inactiveReset) && api.options.dcy.inactiveReset){
						api.elements.content.off( ".inactiveReset" );
					}
				}

				if(isDefined(beforeCloseCallBack) && typeof beforeCloseCallBack === 'function'){//Focus callback
					//beforeCloseCallBack callback
					beforeCloseCallBack(event, api);
				}

				destroyJQTooltip(api.elements.tooltip);
			},
			focus: function(event, api) {
				//Check if manage the solo properties manually
				isDefined(manualSoloForFocusEvent) ? manualSoloForFocusEvent(event, api) : null;

				//Focus callback
				if(isDefined(focusCallBack) && typeof focusCallBack === 'function'){
					focusCallBack(event, api);
				}
			},
			visible: function(event, api) {
				/*
				 * ###################################################################
				 *Manage the scroll in tooltip content when inactive is enabled;
				 *This gesture is use because the native scrollbar not have event focus
				*/
				if(isDefined(api.options.hide.inactive) && api.options.hide.inactive){
					api.elements.content.on('scroll.inactiveReset',function(){
						api.options.dcy.inactiveReset = clearQtipInactiveTimer(api);
					});
				}
				//####################################################################

				/*
				 * #######################################################
				 * Manage the reposition of tooltip
				 * #######################################################
				 */
				if(api.options.dcy.repositionManage){

				}

				//#########################################################

				/*
				 * #######################################################
				 * Manage the scroll of container that content the target
				 * #######################################################
				 */

				api.options.dcy.dcyHandler = getElementsWithScroll([], api.elements.target.get(0));

				var actionOnScrollEvent = function(){
					api.elements.tooltip.qtip('hide');
				};

				for(var i=0;i<api.options.dcy.dcyHandler.length;i++){
					if(isTouchDevice){
						$(api.options.dcy.dcyHandler[i]).on('touchmove.qtipScrollManage',actionOnScrollEvent);
					}
					else{
						$(api.options.dcy.dcyHandler[i]).on('scroll.qtipScrollManage',actionOnScrollEvent);
					}
				}

				//#########################################################

				//Check if manage the solo properties manually
				isDefined(manualSoloForShowEvent) ? manualSoloForShowEvent(event, api) : null;

				if(isDefined(visibleCallBack) && typeof visibleCallBack === 'function'){
					visibleCallBack(event, api);
				}
			}
	};

	//###################################################################################################

	//Return the complete options for initialize tooltips
	return mergedOptions;
};


/* *************************************************************************************************
// Creates a qTip and sets his content with simple HTML code.
// @jqSelector: a selector, element, HTML string, or jQuery object; the tip will be inserted at the end of the element(s) specified by this parameter.
// @title_: text/HTML which will appear inside the title element of the content.
// @text_: text/HTML which will appear inside the tooltip initially.
// @modal_: true/false, this allows you to create tooltips which 'dim' the rest of the page when shown.
// @opts: opts is the array to merged the default options (if null, the function uses default options (qTipDefaultOpts) )
// @beforeCloseCallBack : callback to set in hide event and it execute before hide tooltip
// @beforeOpenCallBack 	: callback to set in show event and it execute before show tooltip
// @setGroup			: This parameter is used for manually manage of solo property
// @renderCallBack 		: callback to set in render event and it execute when tooltip is completely renderized
// @focusCallBack 		: callback to set in focus event and it execute when focus on tooltip
// @visibleCallback		: callback to set in visible event and it execute when tooltip is completely shown
//**************************************************************************************************/
function createJQTooltipWithSimpleHTML(jqSelector, title_, text_, opts, beforeCloseCallBack, beforeOpenCallBack, setGroup, renderCallBack, focusCallBack, visibleCallback){

	$(jqSelector).each(function(index){

		var $currentTargetElement = $(this);
		var currentTipApi = $currentTargetElement.qtip('api');

		var idElement = $(this).attr('id');
		idElement = (idElement != undefined) ? idElement : index;

		if(isDefined(opts) && isDefined(opts.show)){
			  !isDefined(opts.show.delay) ? opts.show.delay = 0 : null;
			  !isDefined(opts.show.ready) ? opts.show.ready = false : null;
		}

		var mergedDefaultOptionsWithCustom = getJQTipDefaultOpts($currentTargetElement, opts, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallback);

		//Set the DCY PARAMETERS and DCY CONTENT for tooltips
		var actualOptions = {
				id: idElement,
				content:{
					text: text_,
					title: {
						text: title_
					}
				}
		};

		var completeOptions = {};

		$.extend(true, completeOptions, mergedDefaultOptionsWithCustom, actualOptions);

		if (!currentTipApi){
			$(this).qtip(completeOptions); //init tooltip
			showTipIfTipEventIsFalse(completeOptions.show.event, this); //show the tooltip if show event is false
		}
		else{

			if(!currentTipApi.options.content.ajax.url){
				if(isDefined(title_) && currentTipApi.options.content.title.text != title_){
					$currentTargetElement.qtip('option', 'content.title.text', title_);
				}

				if(isDefined(text_) && currentTipApi.options.content.text != text_){
					$currentTargetElement.qtip('option', 'content.text', text_);
				}
			}

			if (isDefined(currentTipApi.elements) && isDefined(currentTipApi.elements.tooltip)) {
				if (isDefined(currentTipApi.elements.tooltip.queue) && currentTipApi.elements.tooltip.queue("fx") == "inprogress") {
					currentTipApi.elements.tooltip.queue(function () {
						if (currentTipApi.elements && currentTipApi.elements.tooltip && !currentTipApi.elements.tooltip.is(':visible')){
							showTipIfTipEventIsFalse(completeOptions.show.event, this);
						}
						 $(this).dequeue();
					});
				}
				else
					if (isDefined(currentTipApi.elements.tooltip) && !currentTipApi.elements.tooltip.is(':visible')){
					showTipIfTipEventIsFalse(completeOptions.show.event, this); //show the tooltip if show event is false
				}
			}
		}
	});
};

/* ******************************************************************************
 * Creates a qTip and sets his content using the url in input
// @jqSelector: a selector, element, HTML string, or jQuery object; the tip will
// be inserted at the end of the element(s) specified by this parameter.
// @title_: text/HTML which will appear inside the title element of the content.
// @urlToLoad: a string containing the URL to which the request is sent.
// @opts: opts is the array to overwriting the default options (if null, the function uses default options (qTipDefaultOpts) )
// @beforeCloseCallBack : callback to set in hide event and it execute before hide tooltip
// @beforeOpenCallBack 	: callback to set in show event and it execute before show tooltip
// @setGroup			: This parameter is used for manually manage of solo property
// @renderCallBack 		: callback to set in render event and it execute when tooltip is completely renderized
// @focusCallBack 		: callback to set in focus event and it execute when focus on tooltip
// @visibleCallback		: callback to set in visible event and it execute when tooltip is completely shown
//**************************************************************************************************/
function createJQTooltipWithURL(jqSelector, title_, urlToLoad, opts, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallback){

	$(jqSelector).each(function(index){

		var $currentTargetElement = $(this);
		var currentTipApi = $currentTargetElement.qtip('api');

		var idElement = $(this).attr('id');
		idElement = (idElement != undefined) ? idElement : index;

		var mergedDefaultOptionsWithCustom = getJQTipDefaultOpts($currentTargetElement, opts, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallback);

		mergedDefaultOptionsWithCustom.hide.inactive = mergedDefaultOptionsWithCustom.dcy.defaultInactiveForLoading;

		//Set the DCY PARAMETERS and DCY CONTENT for tooltips
		var actualOptions = {
				overwrite:false,
				id: idElement,
				content:{
					text: getContentForLoading(),
					title: {
						text: title_,
						button: true
					},
					ajax:{
						url: urlToLoad,
						complete: function(data, status){
							var tipAPi = $currentTargetElement.qtip('api');
							tipAPi.options.hide.inactive = tipAPi.options.dcy.defaultInactiveForOptions;
							clearQtipInactiveTimer(tipAPi);
							if ($("*:focus").attr("id")==idElement){
								if (!tipAPi.elements.tooltip.is(':visible')){
									$currentTargetElement.qtip('show');
								}
							}
				        }
					}
				}
		};

		var completeOptions = {};

		$.extend(true, completeOptions, mergedDefaultOptionsWithCustom, actualOptions);

		if (!currentTipApi){
			$(this).qtip(completeOptions); //init tooltip
			showTipIfTipEventIsFalse(completeOptions.show.event, this); //show the tooltip if show event is false
		}else{

			if(completeOptions.content.title.text != title_){
				$currentTargetElement.qtip('option', 'content.title.text', title_);
			}

			$currentTargetElement.qtip('option', 'content.ajax.url', urlToLoad);

			if (isDefined(currentTipApi.elements.tooltip) && !currentTipApi.elements.tooltip.is(':visible')){
				showTipIfTipEventIsFalse(completeOptions.show.event, this);
			}
		}
	});
};

/* ******************************************************************************
 * Creates a qTip and sets his content using the request from DP in input
// @jqSelector: a selector, element, HTML string, or jQuery object; the tip will
// be inserted at the end of the element(s) specified by this parameter.
// @title_: text/HTML which will appear inside the title element of the content.
// @dataProviderId: a string containing the dataProviderId to which the request is sent.
// @opts: opts is the array to overwriting the default options (if null, the function uses default options (qTipDefaultOpts) )
// @context 			: content of tooltip
// @maxHeight			: This parameter is used for manage the property style maxHeight
// @beforeCloseCallBack : callback to set in hide event and it execute before hide tooltip
// @beforeOpenCallBack 	: callback to set in show event and it execute before show tooltip
// @setGroup			: This parameter is used for manually manage of solo property
// @renderCallBack 		: callback to set in render event and it execute when tooltip is completely renderized
// @focusCallBack 		: callback to set in focus event and it execute when focus on tooltip
// @visibleCallback		: callback to set in visible event and it execute when tooltip is completely shown
//**************************************************************************************************/
function createJQTooltipWithDataProvider(jqSelector, title_, dataProviderId, opts, context, maxHeight, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallback){

	$(jqSelector).each(function(index){
		var _self = this;
		var $currentTargetElement = $(_self);
		var currentTipApi = $currentTargetElement.qtip('api');

		var idElement = $(this).attr('id');
		idElement = (idElement != undefined) ? idElement : dataProviderId;

		//if actual tooltip isn't initizialized from ajax content, destroy it for show actual tip
		if(isDefined(currentTipApi) &&!currentTipApi.options.content.ajax.url){
			destroyJQTooltip(this);
			currentTipApi = null;
		}

		//Set the DCY PARAMETERS and DCY CONTENT for tooltips
		var actualOptions = {
				overwrite:true,
				id: idElement,
				content:{
					text: getContentForLoading(),
					title: {
						text: title_,
					},
					ajax:{
						url: emptyJSPCas+"?accessType=accessDOJO&csMLO="+csMLO, //necessario poichè non passa per gestione ajax standard
						data: {revent:'GET_DATA',a0:dataProviderId,a1:context},
						success: function(data, textStatus, xhr) {
							//if (data && data.length > 0 && data.indexOf('errorMsg')==-1){
							if (data && data.length > 0){
								var currentTipApi = $currentTargetElement.qtip('api');
								var $tipContent = $(currentTipApi.elements.content);
								$tipContent.html();
								decorateContentToSelector(data, $tipContent);
								this.reposition(null);
								if (maxHeight) {
									$tipContent.css('height' , 'auto');
									$tipContent.css('max-height' , maxHeight+'px');
									$tipContent.css('overflow-y' , 'auto');
								}
							}else{
								var labelNoResult = LANGUAGES.getOriginalLabel('noResultSrc');
								this.set('content.text',labelNoResult);
							}
						},
				        complete: function(data, status){
				        	this.reposition(true);
				        	var currentTipApi = $currentTargetElement.qtip('api');
				        	currentTipApi.options.hide.inactive = currentTipApi.options.dcy.defaultInactiveForOptions;
				        	clearQtipInactiveTimer(currentTipApi);
				        	var $target = $(_self);
				        	if($target.length && $target.is(':visible')){
				        		if (currentTipApi && !currentTipApi.elements.tooltip.is(':visible')){
				        			$target.qtip('show');
				        		}
				        	}
				        }
					}
				}
		};

		var mergedDefaultOptionsWithCustom =  getJQTipDefaultOpts($currentTargetElement, opts, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallback);

		mergedDefaultOptionsWithCustom.hide.inactive = mergedDefaultOptionsWithCustom.dcy.defaultInactiveForLoading;

		var completeOptions = {};

		$.extend(true, completeOptions, mergedDefaultOptionsWithCustom, actualOptions);

		if(!currentTipApi){
			$currentTargetElement.qtip(completeOptions);
			showTipIfTipEventIsFalse(completeOptions.show.event, this); //show the tooltip if show event is false
		}
		else{
			$currentTargetElement.qtip('option', 'content.title.text', title_);
			$currentTargetElement.qtip('option', 'content.text', getContentForLoading());
			$currentTargetElement.qtip('option', 'content.ajax.data', {revent:'GET_DATA',a0:dataProviderId,a1:context});

			if(isDefined(currentTipApi.elements.tooltip) && !currentTipApi.elements.tooltip.is(':visible')){
				$currentTargetElement.qtip('show');
			}
		}
	});
};

/**
 * Cre un unico tooltip per un gruppo di target, creando un effetto di transizione
 * tra una visualizzazione ed un'altra
 * @param jqSelectorParent
 * @param title_
 * @param dataProviderId
 * @param context
 * @param customEventName
 */
function createJQTooltipWithDPForTargetGroup(jqSelectorParent, targetTip, dataProviderId, context, customEventName, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallback, opts){

	var $nodeTip = $(jqSelectorParent);

	var currentTipApi = $nodeTip.qtip('api');
	var idElement = $(jqSelectorParent).attr('id');
	idElement = (idElement != undefined) ? idElement : customEventName;

	//if actual tooltip isn't initizialized from ajax content, destroy it for show actual tip
	if(isDefined(currentTipApi) && !currentTipApi.options.content.ajax.url){
		destroyJQTooltip(jqSelectorParent);
		currentTipApi = null;
	}

	var $currentTargetElement = $(targetTip);

	if (!currentTipApi){
		opts = $.extend(true, {}, {
								  show:{
									delay:0
							 	  },
								  hide: {
									event: 'unfocus inactive',
									delay: 5000,
									inactive: 10000,
									distance: 500
								  }}, opts);

		var mergedDefaultOptionsWithCustom =  getJQTipDefaultOpts($nodeTip, opts, setGroup, beforeCloseCallBack, beforeOpenCallBack, renderCallBack, focusCallBack, visibleCallback);

		mergedDefaultOptionsWithCustom.hide.inactive = mergedDefaultOptionsWithCustom.hide.inactive !== false ? mergedDefaultOptionsWithCustom.dcy.defaultInactiveForLoading : mergedDefaultOptionsWithCustom.hide.inactive;

		$nodeTip.qtip(jQuery.extend({}, mergedDefaultOptionsWithCustom,
		{
			id: idElement,
			content:{
				text: getContentForLoading(),
				ajax:{
					url: emptyJSPCas+"?accessType=accessDOJO&csMLO="+csMLO, //necessario poichè non passa per gestione ajax standard
					data: {revent:'GET_DATA',a0:dataProviderId,a1:context},
					success: function(data, textStatus, xhr) {
						var currentTipApi = $nodeTip.qtip('api');
						var $tipContent = $(currentTipApi.elements.content);
						//if (data && data.length > 0 && data.indexOf('errorMsg')==-1){
						if (data && data.length > 0){
							if (data != null && typeof data == "string" && data != '') {
								jsons = JSON.parse(data);
							}
							$tipContent.html();
							decorateContentToSelector(data, $tipContent);
							clearQtipInactiveTimer(currentTipApi);
							this.reposition(null);
						}else{
							var labelNoResult = LANGUAGES.getOriginalLabel('noResultSrc');
							$currentTargetElement.qtip('option', 'content.text', labelNoResult);
						}
					},
			        complete: function(data, status){
		        		this.reposition(true);
		        		var currentTipApi = $currentTargetElement.qtip('api');
		        		currentTipApi.options.hide.inactive = currentTipApi.options.dcy.defaultInactiveForOptions;
		            	clearQtipInactiveTimer(currentTipApi);
		        		if(!isDefined(currentTipApi) || !isDefined(currentTipApi.elements.tooltip) || !currentTipApi.elements.tooltip.is(':visible')){
		        			$currentTargetElement.qtip('show');
		        		}
			        }
				}
			}
		}));
	}else{
		currentTipApi = $.extend(true, {}, currentTipApi, opts || {});
		$currentTargetElement.qtip('option', 'content.ajax.data', {revent:'GET_DATA',a0:dataProviderId,a1:context});
		$currentTargetElement.qtip('option', 'position.target', targetTip);
		if(!isDefined(currentTipApi.elements.tooltip) || !currentTipApi.elements.tooltip.is(':visible')){
			$currentTargetElement.qtip('show');
		}
	}
};

//Genera il menu items del tagCollector
function createJQTooltipForDecorators(jqSelector, dataProviderId, context, maxHeight, opts){
	var opts = {
			show: {
				event : 'click',
			},
			hide: {
				fixed: true,
				delay: 5000
			}
		};

	if(!ENV_VARS.isOnTouchDevice()){
		opts.hide = {
				event: 'unfocus inactive'
		};
	}

	createJQTooltipWithDataProvider(jqSelector, '', dataProviderId, opts, context, maxHeight, 'tipTagCollectorMenu');
};

function createJQTooltipByDataProviderWithHeight(jqSelector, dataProviderId, context, maxHeight, opts){
	createJQTooltipWithDataProvider(jqSelector, '', dataProviderId, opts, context, maxHeight);
};
function createJQTooltipByDataProvider(jqSelector, dataProviderId, context, options){
	createJQTooltipWithDataProvider(jqSelector, '', dataProviderId, options, context, null);
};
function createJQTooltipByDPWithTitle(jqSelector, dataProviderId, context, title){
	createJQTooltipWithDataProvider(jqSelector, title, dataProviderId, null, context, null);
};
function createJQTooltipByDPWithTitleAndOpts(jqSelector, dataProviderId, context, title, opts){
	createJQTooltipWithDataProvider(jqSelector, title, dataProviderId, opts, context, null);
};

/* *************************************************************************************************
 * Sets the tooltip 's content for loading
 ************************************************************************************************* */
function getContentForLoading(){
	return '<div class="tagsLoading" alt="Loading..." style="float:none;padding-right:4px;"/>';
};

/**
 * Funzionalità simile alla standard: crea un tooltip con come contenuto il valore dell'attributo html TITLE
 * @author fferraiu
 * @param jqSelector
 */
function showJQTooltipByTitle(jqSelector) {
    $(jqSelector).each(function(index){
		var api = $(this).qtip('api');
		if (!api){
			setJQtipOnElement(jqSelector,jqSelector.get(0).title,null,'top center','bottom center');
		}
		else if(!api.elements.target.is(':visible')){
			showJQTooltip(jqSelector);
		}
    });
}

//Per visualizzazione JQtip generico su qualsiasi elemento DOM
function setJQtipOnElement(selector, textForTooltip, setGroup, selectorPosition, qtipPosition, options, title){

	if (textForTooltip == '***NONE***')
		return;

	var selectorPositionShow 	= isDefined(selectorPosition) ? selectorPosition : 'bottom left';
	var qtipPositionShow 		= isDefined(qtipPosition) ? qtipPosition : 'top left';

	var myOptions = null;

	if(!isDefined(options)){
		//Set the options for qtip
		myOptions = {
					position: {
						my: selectorPositionShow,
						at: qtipPositionShow
					},
					style: {
						textAlign: 'center'
					},
					show:{
						event : 'mouseover',
						delay : 500
					},
					hide:{
						delay: 500
					}
			};
	}
	else{
		myOptions = options;
	}


	if(!isDefined(textForTooltip) || textForTooltip == ''){
		textForTooltip = selector.innerHTML;
	}

	if(isDefined(textForTooltip)){
		createJQTooltipWithSimpleHTML(selector, title, textForTooltip, myOptions, null, null, setGroup);
	}
}

//Controlla se è applicato ellipsis su elemento DOM
function ifEllipsisApplied(element){
	var elementScroll 	= element.scrollWidth - 1;
	var elementWidth 	= element.offsetWidth;

	if(elementScroll > elementWidth){
		return true;
	}

	return false;
}


//Controlla se applicata classe de_cursorHand (cursor:pointer)
function ifCursorHandApplied(element, cursorClassDisabled){
	var cursorClassDefault 	= 'de_cursorDefault';
	var cursorClassHand 	= 'de_cursorHand';
	var disableClass		= 'tagRemovedStyle';

	var onclickNotDefinedOnElement = !isDefined($(element).attr('onclick')) || $(element).attr('onclick') == "stopPropagation(event);return false;";

	if(!$(element).hasClass(cursorClassDefault) && !$(element).hasClass(cursorClassHand) && $(element).css('cursor') != 'pointer'){
		$(element).addClass(cursorClassHand);
	}

	!isDefined(cursorClassDisabled) ? cursorClassDisabled = false : null;

	if(onclickNotDefinedOnElement && (cursorClassDisabled || (cursorClassHand && !ifEllipsisApplied(element) && $(element).hasClass(disableClass))) ){
		$(element).removeClass(cursorClassHand).addClass(cursorClassDefault);
	}
}

/**
 * Funzione per il settaggio di un tootip soltanto nel caso in cui
 * sul nodo passato sia esposto del testo troncato da Ellipsis
 *
 * Author : Pagano Francesco
 * @param element: DOM element
 */
function setTooltipOnEllipsis(selector, textForTooltip, cursorClassDisabled){

	!isDefined(cursorClassDisabled) ? cursorClassDisabled = true : null;

	textForTooltip = isDefined(textForTooltip) && textForTooltip != "" ? textForTooltip : selector.innerHTML;

	var qtipOptions = {
			position: {
				my: 'bottom left',
				at: 'top left'
			},
			style: {
				textAlign: 'center'
			},
			show:{
				event : 'mouseover',
				delay : 500
			},
			hide:{
				delay: 0
			}
	};

	if(ifEllipsisApplied(selector)){
		ifCursorHandApplied(selector, cursorClassDisabled);
		createJQTooltipWithSimpleHTML(selector, null, textForTooltip, qtipOptions, null, null, 'ellipsis');
	}
}


function closeAllTips() {
	 $('.qtip.ui-tooltip').qtip('hide');
}

function closeOtherTips(event) {
	var srcElem = event.target || event.srcElement || event.originalTarget;
	var thisQtip = $(srcElem).parents('.qtip.ui-tooltip');
	$('.qtip.ui-tooltip').each(function(){
		if (!$(this).is(thisQtip)) {
			$(this).qtip('hide');
		}
	});
}

//Set the show event for the current device
function forcedEventsQtip(options){
	if(isDefined(options.content.title.button) && options.content.title.button ){
		options.hide.inactive 	= false;
		options.hide			= false;
	}

	if(isTouchDevice){
		options.hide.inactive 	= options.hide.inactive !== false ? 10000 : options.hide.inactive;
		options.hide.event 		= 'unfocus inactive';
		options.show.event 		= $.browser.msie ? 'MSPointerUp' : 'touchend';
		options.show.ready		= true;
	}

	return options;
};

function openOtherTooltipByDP(currentNode, contentId, tooltipTitle, controllerUid, discRefObjId, discRefObjType, exludedIds) {
	var selector = "#" + contentId;
	var $content = $(selector);

	var options = getOptionsForCloseTooltip(true, 200);

	// Se ho già il contentuto renderizzato lo apro
	if ($content.size() && $content.html().trim()) {
		createJQTooltipWithSimpleHTML($(currentNode), tooltipTitle, $content.html(), options);
	}
	// Se non ho il contenuto renderizzato lo creo tramite DP
	else {
		var context = getCtx($content);

		var ctx = buildNewCtxObject();
		addDataToCtx(ctx, 'owner', getCtxValue("owner", context));
		addDataToCtx(ctx, 'discRefObjId', discRefObjId);
		addDataToCtx(ctx, 'discRefObjType', discRefObjType);
		if (isDefined(exludedIds)) {
			addDataToCtx(ctx, 'excludeIds', exludedIds);
		}
		var rasterCtx = getRasterCtxContainer(ctx);

		var callback = function (response, selector, controllerUid, contextIn) {
			decorateContentToSelector(response, selector, controllerUid, contextIn);
			createJQTooltipWithSimpleHTML($(currentNode), tooltipTitle, $content.html(), options);
		};

		requestProviderDataForContext(rasterCtx, selector, controllerUid, callback);

	}
}

// Restituisce le options da utilizzare con i tooltip con la x di chiusura
function getOptionsForCloseTooltip(solo, styleWidth, styleClass) {
	var options = {
			content:{
				title: {
					button: true
				}
			},
			style: {
				width: styleWidth ? styleWidth : false,
				classes: 'de_qtip ' + styleClass
			},
			show: {
				solo: solo ? solo : false
			},
			hide: {
				event: false,
				inactive : false
			}
		};

	return  options;
}


/* *************************************************************************************
 * If the tipEvent is set to false, the tooltip will be shown immediately when created
 ************************************************************************************* */
function showTipIfTipEventIsFalse(tipEvent, selector){
	if (!tipEvent){
		$(selector).qtip('show');
	}
};
/* ***************************************************************************
* Append click event to selector to show the tooltip
* ***************************************************************************/
function appendClickEventToSelector(jqSelector){
	$(jqSelector).each(function(){
		$(this).bind('click', function() {
			showJQTooltip(this);
		});
	});
};
/* ***************************************************************************
* Show the tooltip
* ***************************************************************************/
function showJQTooltip(jqSelector){
	$(jqSelector).each(function(){
		$(this).qtip('show');
	});
};
/* ***************************************************************************
* Hide the tooltip
* ***************************************************************************/
function hideJQTooltip(jqSelector){
	$(jqSelector).each(function(){
		$(this).qtip('hide');
	});
};
/* ***************************************************************************
* Destroy the tooltip
* ***************************************************************************/
function destroyJQTooltip(jqSelector){
	$(jqSelector).each(function(){
		$(this).qtip('destroy', true);
	});
};
/* ***************************************************************************
* Return the formatted json response
*************************************************************************** */
function getDataJSON(data){
	var result = "";
	for (var i=0;i<data.length;i++)	{
		result = result + "<h4>"+data[i].key+" - "+data[i].name+" - "+data[i].desc+" - "+data[i].type+" - "+data[i].url+"</h4><br>";
	}
	return result;
};

/* ***************************************************************************
* Sets the title options for the qTip content
* ***************************************************************************/
function setJQTooltipTitle(jqSelector, title_, button_){
	$(jqSelector).each(function(){
		//you can change the title text, only it exists
		if ($(this).qtip('option', 'content.title.text')!=false){
			$(this).qtip('option', {
			   'content.title.text': title_
			});
		}

		//you can change the title button, only it exists
		if ($(this).qtip('option', 'content.title.button')!=false){
			$(this).qtip('option', {
			   'content.title.button': button_
			});
		}

	});
};
/* ***************************************************************************
* Sets the content options for the qTip
*************************************************************************** */
function setJQTipContentOpts(jqSelector, text_){
	$(jqSelector).each(function(){
		$(this).qtip('api').set({
			'content.text': text_
		});
	});
};
/* ***************************************************************************
* Sets the position options for the qTip
*************************************************************************** */
function setJQTipPositionOpts(jqSelector, my_, at_){
	$(jqSelector).each(function(){
		$(this).qtip('api').set({
			'position.my': my_,
			'position.at': at_
		});
	});
};
/* ***************************************************************************
* Sets the style options for the qTip
*************************************************************************** */
function setJQTipStyleOpts(jqSelector, classes_, widget_){
	$(jqSelector).each(function(){
		$(this).qtip('api').set({
			'style.classes': classes_,
			'style.widget': widget_
		});
	});
};
/* ***************************************************************************
* Sets the show options for the qTip
*************************************************************************** */
function setJQTipShowOpts(jqSelector, tipEvent_, target_, effect_, delay_, solo_, ready_, modal_){
	$(jqSelector).each(function(){
		$(this).qtip('api').set({
			'show.event': tipEvent_,
			'show.target': $(target_),
			'show.effect': effect_,
			'show.delay': delay_,
			'show.solo': solo_,
			'show.ready': ready_,
			'show.modal': modal_
		});
	});
};
/* ***************************************************************************
* Sets the hide options for the qTip
*************************************************************************** */
function setJQTipHideOpts(jqSelector, tipEvent_, target_, effect_, delay_, inactive_, fixed_){
	$(jqSelector).each(function(){
		$(this).qtip('api').set({
			'hide.event': tipEvent_,
			'hide.target': $(target_),
			'hide.effect': effect_,
			'hide.delay': delay_,
			'hide.inactive': inactive_,
			'hide.fixed': fixed_
		});
	});
};

/* ***************************************************************************
* Clear Timer of inactive option for qtip
*************************************************************************** */
function clearQtipInactiveTimer(api){
	if(isDefined(api.options.hide.inactive) && api.options.hide.inactive){
		clearTimeout(api.timers.inactive);
		return true;
	}
	return false;
}


function setJQtipOnElementForPerformanceDialog(selector, txtMessage, group, qtipTitle){
	//to do per la query applicare una classe che mantenga il word break o che tolga l'owerflow a hidden
	var myOption = getOptionsForCloseTooltip(null, null, 'performance');

	setJQtipOnElement(selector,"<div style=\"display:inline-block\">"+unescape(txtMessage)+"</div>", group, null, null, myOption, qtipTitle);
}

//# sourceMappingURL=jqTooltip.js.map
;
